export default __webpack_public_path__ + "static/media/full-logo.ee1c141d.png";